import { createFileRoute } from "@tanstack/react-router";
import {
  categoriesWithReferencesQueryOptions,
  categoryBySlugQueryOptions,
  finishedReferencesInfiniteQueryOptions,
} from "src/react-query/react-query";
import { ReferenceFilter } from "src/components/references/ReferenceFilter";
import { InfiniteReferencesGrid } from "src/components/references/InfiniteReferencesGrid";
import { seo } from "src/utils/seo";

export const Route = createFileRoute(
  "/_breadcrumbs/_referenceBreadcrumb/reference/kategorie/$categorySlug",
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const [category, , rawCategories] = await Promise.all([
      context.queryClient.ensureQueryData(
        categoryBySlugQueryOptions(params.categorySlug),
      ),
      context.queryClient.ensureInfiniteQueryData(
        finishedReferencesInfiniteQueryOptions({
          categorySlug: params.categorySlug,
        }),
      ),
      context.queryClient.ensureQueryData(
        categoriesWithReferencesQueryOptions(),
      ),
    ]);

    const categoryName = category?.name || params.categorySlug;

    return {
      categoryName,
      crumb: categoryName,
      rawCategories,
    };
  },
  head: ({ params, loaderData }) => {
    return {
      meta: [
        ...seo({
          title: `Reference - ${loaderData?.categoryName || params.categorySlug} | VESAS`,
          description: `Reference z kategorie ${loaderData?.categoryName}`,
        }),
      ],
    };
  },
});

function RouteComponent() {
  const { rawCategories } = Route.useLoaderData();
  const params = Route.useParams();

  if (!rawCategories) {
    return <div>Žádné kategorie nebyly nalezeny</div>;
  }

  return (
    <div className={"container mx-auto"}>
      <ReferenceFilter
        defaultTabSlug={params.categorySlug}
        rawCategories={rawCategories}
      />
      <InfiniteReferencesGrid categorySlug={params.categorySlug} />
    </div>
  );
}
